<template>
    <div class="header_containter">
        <alertModal
            v-if="alertModalData && alertModalData.shown"
            :titleTxt="alertModalData.titleTxt"
            :bodyTxt="alertModalData.bodyTxt"
            :submitBtnTxt="alertModalData.submitBtnTxt"
            :cancelBtnTxt="alertModalData.cancelBtnTxt"
            
            @cancelClicked="alertModalData.cancelFun"
            @submitClicked="alertModalData.submitFun"
        />
        <sideMenu
            v-if="sideMenuShown"
            @hideMenu="sideMenuShown=false"
        />
        <header ref="header">
            <createGifModal v-if="creationModalShown" @hideModal="creationModalShown=false" />
            <router-link to="/" class="logo_s">
                <img src="@/assets/images/gif_banana_logo_s.svg" alt="" srcset="">
            </router-link>
            <div class="header-right-cont">
                <button @click="createQuizBtn" v-if="createBtn" class="btn btn-l btn-primary create-quiz-btn">Create Quiz!</button>
                <button class="side-menu-btn" @click="sideMenuShown=true">
                    <img src="@/assets/images/icons/24/menu.svg" alt="">
                </button>
            </div>
        </header>
    </div>
</template>

<script>

    // Components
    import sideMenu from '@/components/sideMenu'
    import createGifModal from '@/components/createGifModal'
    import alertModal from '@/components/alertModal'

export default {

    name: 'pageHeader',
    props: {
        createBtn: Boolean,
        alertModal: Object,
    },
    components: {
        sideMenu,
        createGifModal,
        alertModal,
    },
    watch: {
        alertModal: {
            handler(val) {
                this.alertModalData = val;
            },
            deep: true,
        }
    },
    data() {
        return {
            sideMenuShown: false,
            creationModalShown: false,
            durationBetweenPosts: 2 * 60 * 1000, // 2 mins
            alertModalData: {},
        }
    },
    methods: {
        createQuizBtn() { 
            if (this.postAllowanceChecker()) {
                this.creationModalShown = true;
            } else {
                this.alertModalData = {
                    shown: true,
                    titleTxt: "Whoa! Take it easy",
                    bodyTxt:"You can only post 1 quiz every 2 minutes.",
                    submitBtnTxt:"Got it",
                    cancelBtnTxt: null,
                    cancelFun: function(){console.log('Cancel button clicked!')},
                    submitFun: this.dismissAlert,
                }
            }
        },
        dismissAlert() {
            this.alertModalData.shown = false;
        },
        getLastPosted() {
            if (localStorage.getItem('lastPosted')) {
                return localStorage.getItem('lastPosted');
            } else {
                return null;
            }
        },
        postAllowanceChecker() {
            let currentTime = new Date().getTime();
            let lastPosted = parseInt(this.getLastPosted());
            let durationBetweenPosts = this.durationBetweenPosts;

            if (lastPosted && !isNaN(lastPosted)) { // Check if value exist and make sure it's a number
                if ((currentTime-lastPosted) > durationBetweenPosts) {
                    // console.log('✅ User can post');
                    return true;
                } else {
                    // console.log('🚫 User cannot post. Show error alert');
                    return false;
                }
            } else { // If there's no lastPosted = this is the first post
                // console.log('✅ User can post');
                return true;
            }
        },
    },
    mounted() {
    }
}
</script>

<style>

</style>